module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_3.bc332568.png";